import { defineStore } from 'pinia'

 const useModules = defineStore('fold', {
	state: () => {
		return {
			is_fold: true,
			todo_num: 0
		}
	},
	getters: {
	
	},
	actions: {
		setfold (data) {
		  this.is_fold=data
		},
		set_todo_num (data) {
			this.todo_num= data
		}
	}
})

export default useModules